import { Type } from 'class-transformer';
import { Model } from './model';
import { Checkout } from './checkout';

export class StripeCheckout extends Model {
  client_secret: string;
  session_id: string;
}

export class StripeIntentCheckout extends Model {
  @Type(() => Checkout)
  checkout: Checkout;
  payment_intent_id: string;
}

export enum StripePaymentIntentStatus {
  CANCELED = 'canceled',
  PROCESSING = 'processing',
  REQUIRES_ACTION = 'requires_action',
  REQUIRES_CAPTURE = 'requires_capture',
  REQUIRES_CONFIRMATION = 'requires_confirmation',
  REQUIRES_PAYMENT_METHOD = 'requires_payment_method',
  SUCCEEDED = 'succeeded',
}

export class StripePaymentResult extends Model {
  @Type(() => Checkout)
  checkout: Checkout;
  payment_intent_id: string;
  status: StripePaymentIntentStatus;
  client_secret?: string | null;
  // Fields for microdeposit verification (ACH bank payments)
  next_action_type?: string | null;
  hosted_verification_url?: string | null;
  microdeposit_type?: 'descriptor_code' | 'amounts' | null;
  microdeposit_arrival_date?: number | null;
  // Error code from last payment attempt (e.g., "payment_intent_payment_attempt_expired")
  last_payment_error_code?: string | null;
}
